import toast from 'react-hot-toast';

export const successToaster = (msg) => toast.success(msg)

export const ErrorToaster = (msg) => toast.error(msg)

export const WarnToaster = (msg) => toast(msg, {
    icon: '⚠️',
    style: {
      border: '1px solid #FFA500',
      padding: '16px',
      color: '#FFA500',
    },
  });
